// extracted by css-extract-rspack-plugin
export default {"layer":"GlobeTravel-module__layer"};